import React, { Component, useEffect } from 'react';
import { Carousel } from '@thd-olt-component-react/carousel';
import { Col, Row } from '@thd-olt-component-react/grid';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import { Image } from '@thd-olt-component-react/image';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import {
  arrayOf, bool, func, number, shape, string
} from 'prop-types';
import classNames from 'classnames';
import Helper from '../../Helper';
import Threesixty from '../Threesixty';
import { mediaClick } from '../../../publisher';
import { InteractiveMediaOverlay } from './InteractiveMediaOverlay';
import './media-gallery-overlay-mobile.style.scss';

class MediaGalleryOverlayMobile extends Component {

  constructor(props) {
    super(props);
    this.videoRefs = [];
    this.mobileOverlayRef = React.createRef({});
    this.imageChangeRef = React.createRef({});

    const { selectedMainImageIndex, selectedThumbnailIndex } = props;
    this.state = {
      mainImage: null,
      mainImagesBuffer: [],
      zoomScale: 1,
      secondOverlayOpened: false,
      trayThumbnails: [],
      trayMainImages: [],
      selectedMainImageIndex,
      selectedThumbnailIndex,
      isPortrait: true,
      reset: () => {},
    };
  }

  componentDidMount = () => {
    const { overlayOpened } = this.props;
    this.setTrayThumbnailsElements();
    this.setTrayMainImagesElements();
    this.disableScroll(overlayOpened);
    this.checkResolution();
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', this.onPopstate, false);
      window.addEventListener('resize', this.checkResolution, false);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { zoomScale, selectedThumbnailIndex, selectedMainImageIndex, reset } = this.state;
    if (prevState.selectedThumbnailIndex !== selectedThumbnailIndex) {
      this.setTrayThumbnailsElements();
    }
    const eitherIndexChanged = prevState.selectedThumbnailIndex !== selectedThumbnailIndex
      || prevState.selectedMainImageIndex !== selectedMainImageIndex;
    if (eitherIndexChanged) {
      reset();
    }
    // Update tray images when user zoom change
    if (prevState.zoomScale !== zoomScale) {
      this.setTrayMainImagesElements();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onPopstate, false);
    window.removeEventListener('resize', this.checkResolution, false);
    document.body.style.overflow = 'auto';
  }

  checkResolution = () => {
    if (typeof window !== 'undefined') {
      const LANDSCAPE_MIN_WIDTH = 550;
      let isPortrait = true;
      const windowWidth = window.innerWidth;
      if (windowWidth >= LANDSCAPE_MIN_WIDTH) {
        isPortrait = false;
      }
      this.setState({ isPortrait });
    }
  };

  onChangeImage = (index) => {
    const { mainImages } = this.props;
    const { mainImagesBuffer } = this.state;

    mainImagesBuffer[index] = mainImages[index];
    this.setState({ mainImagesBuffer });
    this.setTrayMainImagesElements();

    const payload = {
      section: 'expanded-view',
      component: 'thumbnails',
      target: mainImages[index].type,
      position: index + 1
    };

    mediaClick(payload);

    this.setState({
      selectedMainImageIndex: index,
      selectedThumbnailIndex: index,
      mainImagesBuffer
    });
    this.setTrayMainImagesElements();
  };

  onChangeMedia = (mainImage) => {
    this.setState({
      secondOverlayOpened: true,
      mainImage
    });
    if (typeof window !== 'undefined') {
      window.history.pushState({ page: 'MEDIASECONDOVERLAY' }, null, '');
    }
  };

  onPopstate = () => {
    const { handleClose, overlayOpened } = this.props;
    if (overlayOpened) {
      handleClose();
    }
  };

  setTrayThumbnailsElements = () => {
    const { product = {}, thumbnails } = this.props;
    const { identifiers = {} } = product;
    const { brandName, productLabel } = identifiers;
    const { selectedThumbnailIndex } = this.state;
    const trayThumbnails = thumbnails.map((thumb, thumbIndex) => {
      const thumbnailStyle = classNames(
        'overlay-mobile__thumbnail__image-block',
        { 'overlay-mobile__thumbnail__image-block--selected': (selectedThumbnailIndex === thumbIndex) }
      );

      const { id } = thumb;
      const isImage360 = Helper.isImage360({ media: thumb });
      const isVideo = Helper.isVideo({ media: thumb });
      const isAR = Helper.isAR({ media: thumb });

      return (
        <div key={id} className="overlay-mobile__thumbnail__wrapper">
          <button
            type="button"
            className={thumbnailStyle}
            ref={this.imageChangeRef}
            onClick={() => this.onChangeImage(thumbIndex)}
          >
            {isImage360
            && (
              <>
                <span className="background-circle background-circle--thumbnail" />
                <span className="threesixty-icon threesixty-icon--thumbnail" />
              </>
            )}
            {isVideo
            && (
              <>
                <span className="background-circle background-circle--thumbnail" />
                <span className="play-icon play-icon--thumbnail" />
              </>
            )}
            {isAR
            && (
              <>
                <span className="background-circle background-circle--thumbnail" />
                <span className="ar-icon ar-icon--thumbnail-mobile" />
              </>
            )}
            <Image
              className="overlay-mobile__thumbnail-image"
              src={thumb.mediaStill || thumb.videoStill || thumb.url}
              alt={`${brandName} ${productLabel}`}
              lazy
            />
          </button>
        </div>
      );
    });
    this.setState({
      trayThumbnails
    });
  };

  setTrayMainImagesElements = () => {
    const { product, mainImages, zoomedImages } = this.props;
    const { identifiers = {} } = product;
    const { brandName, productLabel } = identifiers;
    const {
      isPortrait, mainImagesBuffer, zoomScale, selectedMainImageIndex
    } = this.state;
    const mainImagesBufferTemp = mainImagesBuffer;
    if (mainImagesBuffer.length === 0) {
      while (mainImagesBufferTemp.length < mainImages.length) {
        mainImagesBufferTemp.push('');
      }
      mainImagesBufferTemp[selectedMainImageIndex] = mainImages[selectedMainImageIndex];
    }
    const trayMainImages = mainImagesBufferTemp.map((mainImage, imageIndex) => {
      const isImage = Helper.isImage({ media: mainImage });
      const isImage360 = Helper.isImage360({ media: mainImage });
      const isVideo = Helper.isVideo({ media: mainImage });
      const isAR = Helper.isAR({ media: mainImage });
      let videoEl = null;

      // if the asset is a video
      if (isVideo) {
        // grab the element
        videoEl = document.getElementById(`bcvideo_${mainImage.videoId}_html5_api`);
      }

      // if the video element exists
      if (videoEl) {
        // we are on a different asset so pause video
        this.pauseVideo(videoEl);
      }

      const zoomOutClasses = classNames({
        'overlay-mobile__normal-image-wrapper': !(isImage360 || isVideo)
      });

      return (
        <div className="overlay-mobile__main-asset">
          <div className={zoomOutClasses}>
            {isImage && (
              <TransformWrapper
                defaultPositionX={200}
                defaultPositionY={100}
                doubleClick={{
                  mode: zoomScale < 8 ? 'zoomIn' : 'reset',
                }}
              >
                {({ resetTransform, scale }) => (
                  <>
                    <TransformComponent>
                      <Image
                        className="overlay-mobile__main-content overlay-mobile__main-image-wrapper"
                        src={zoomedImages[imageIndex].url}
                        alt={`${brandName} ${productLabel}`}
                        lazy
                      />
                    </TransformComponent>
                    {this.setState({
                      reset: resetTransform,
                      zoomScale: [1, 8].indexOf(scale) > -1 ? scale : 1
                    })}
                  </>
                )}
              </TransformWrapper>

            )}

            {isImage360
            && (
              <button type="button" className="overlay-mobile__second-overlay-portrait" onClick={() => this.onChangeMedia(mainImage)}>
                <span className="background-circle background-circle--main" />
                <span className="threesixty-icon threesixty-icon--main" />
                <Image
                  className="overlay-mobile__main-content"
                  src={mainImages[imageIndex].mediaStill}
                  alt={`${brandName} ${productLabel}`}
                  lazy
                />
              </button>
            )}

            {isVideo
            && (
              <button type="button" className="overlay-mobile__second-overlay-portrait" onClick={() => this.onChangeMedia(mainImage)}>
                <span className="background-circle background-circle--main" />
                <span className="play-icon play-icon--main" />
                <Image
                  className="overlay-mobile__main-content"
                  src={mainImages[imageIndex].videoStill}
                  alt={`${brandName} ${productLabel}`}
                  lazy
                />
              </button>
            )}

            {isImage360
            && (
              <Threesixty
                className="overlay-mobile__second-overlay-landscape overlay-mobile__main-content overlay-mobile__main-content__normal"
                media={mainImage}
              />
            )}
            {isVideo && !isPortrait
            && (
              <div className="overlay-mobile__second-overlay-landscape overlay-mobile__main-content overlay-mobile__main-content__video">
                <VideoPlayer iframe videoId={mainImage.videoId} channel="mobile" />
              </div>
            )}
            {isAR && (
              <button type="button" onClick={() => this.handleOnPageARClick({ media: mainImage })}>
                <Image
                  className="overlay-mobile__main-content"
                  src={mainImage.mediaStill}
                  alt={`${brandName} ${productLabel}`}
                  lazy
                />
                <span className="background-circle background-circle--main" />
                <span className="ar-icon ar-icon--main" />
              </button>
            )}
          </div>
        </div>
      );
    });
    this.setState({
      mainImagesBuffer: mainImagesBufferTemp,
      trayMainImages
    });
  };

  pauseVideo = (video) => {
    if (video) {
      video.pause();
    }
  }

  hideSecondOverlay = () => {
    this.setState({ secondOverlayOpened: false });
  };

  handleOnPageARClick = ({ media }) => {
    const { handleClose, onMediaClick, overlayOpened } = this.props;
    if (overlayOpened && handleClose) {
      handleClose();
    }
    if (onMediaClick) {
      onMediaClick({
        media
      });
    }
    this.arAssetAnalytics();
  };

  arAssetAnalytics = () => {
    const payload = {
      section: 'see it in your space',
      component: 'augmented reality',
      target: 'expanded-view'
    };
    mediaClick(payload);
  };

  disableScroll = (open) => {
    if (open) {
      document.body.style.overflow = 'hidden';
    }
  };

  determineSwipeTolerance = () => {
    const { mobileOverlayRef } = this;
    const { isPortrait } = this.state;
    const oNode = mobileOverlayRef.current;
    const width = oNode ? oNode.clientWidth : 0;
    const TOLERANCE_FACTOR = 0.55;
    const tolerancex = !isPortrait ? width : width * TOLERANCE_FACTOR;
    return tolerancex || 5;
  };

  render() {
    const {
      handleClose,
      mainImages,
      overlayOpened
    } = this.props;

    const {
      mainImage,
      secondOverlayOpened,
      isPortrait,
      selectedMainImageIndex,
      selectedThumbnailIndex,
      trayMainImages,
      trayThumbnails
    } = this.state;

    const isImage = Helper.isImage({ media: mainImages[selectedMainImageIndex] });
    const toleranceSwipe = this.determineSwipeTolerance();
    const showHideClassName = overlayOpened ? 'overlay-mobile overlay-mobile__display-block' : 'overlay-mobile overlay-mobile__display-none';
    const collectionLink = mainImages[selectedMainImageIndex]?.collection;
    return (
      <>
        <div className={showHideClassName}>
          <section className="overlay-mobile__wrapper">
            <div className="overlay-mobile__main-content">
              <button onClick={handleClose} type="button">
                <Image
                  className="overlay-mobile__back-icon"
                  src="https://assets.thdstatic.com/images/v1/back-arrow-grey.svg"
                  alt="Back"
                  lazy
                />
                <span className="overlay-mobile__back-text">Back</span>
              </button>
            </div>
            <Row>
              <Col xs={5}>
                <div className="overlay-mobile__carousel-wrapper" ref={this.mobileOverlayRef}>
                  <Carousel
                    carouselParentRef={this.mobileOverlayRef}
                    showArrows={isPortrait}
                    multiItem={false}
                    showDots={false}
                    selectedItem={selectedMainImageIndex}
                    onChange={this.onChangeImage}
                    tolerancex={toleranceSwipe}
                  >
                    {trayMainImages}
                  </Carousel>
                  {collectionLink
                  && (
                    <div className="shopThisRoomContainer">
                      <a className="shopThisRoomLink" href={collectionLink} onClick={(e) => e && e.stopPropagation()}> Shop This Room </a>
                    </div>
                  )}

                  {isImage && <div className="overlay-mobile__image-caption">Pinch Image to Zoom In</div>}
                </div>
              </Col>
              <Col xs={7}>
                <div className="overlay-mobile__thumbnails">
                  <div className="overlay-mobile__thumbnails--portrait">
                    <Carousel
                      showArrows={false}
                      itemWidthMobile="10%"
                      showDots={false}
                      selectedItem={selectedThumbnailIndex}
                    >
                      {trayThumbnails}
                    </Carousel>
                  </div>
                  <div className="overlay-mobile__thumbnails--landscape">
                    {trayThumbnails}
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </div>
        {secondOverlayOpened
        && (
          <InteractiveMediaOverlay
            onClose={this.hideSecondOverlay}
            mainImage={mainImage}
            open={secondOverlayOpened}
          />
        )}
      </>
    );
  }
}

MediaGalleryOverlayMobile.propTypes = {
  handleClose: func,
  mainImages: arrayOf(shape({})),
  overlayOpened: bool,
  onMediaClick: func,
  selectedMainImageIndex: number,
  selectedThumbnailIndex: number,
  product: shape({}),
  thumbnails: arrayOf(shape({
    id: string,
    location: string,
    mediaType: string
  })),
  zoomedImages: arrayOf(shape({}))
};

MediaGalleryOverlayMobile.defaultProps = {
  handleClose: null,
  mainImages: [],
  overlayOpened: false,
  onMediaClick: null,
  selectedMainImageIndex: 0,
  selectedThumbnailIndex: 0,
  product: {},
  thumbnails: [],
  zoomedImages: []
};

export default MediaGalleryOverlayMobile;
